  <div class="icons-view-panel">
    <wms-message name="importIcon" *ngIf="showErrorMsg" [scopeDataset]="errorMessage"></wms-message>
    <a (click)="goBack()" *ngIf="showUploadFont">
      <i class="wm-icon wms wms-chevron-left back-icon"></i>Back</a>

    <div class="icon-panel">
      <h4>{{locale.LABEL_UPLOAD_ICON_FONTS}}</h4>
      <p>{{locale.MESSAGE_UPLOAD_ICON_FOMTS}}</p>
    </div>
    <div class="upload-files-container">
      <label class="upload-icon-button col-xs-4" *ngIf="!ttfFile">
        <i class="wms wms-upload upload-icon"></i>
        <p class="upload-text">{{locale.LABEL_UPLOAD_TTF_FILE}}</p>
        <input  id="import-project-file-upload"
                [ngModel]="ttfFile"
                type="file"
                (change)="validateTTFFile($event)"
                name="wmTTFFile" accept=".ttf" class="wm-file-uploader">
      </label>
      <div class="upload-icon-button uploaded-file-button" *ngIf="ttfFile" >
        <i class="wms wms-cancel upload-icon cross-icon" (click)="removeFile('ttf')"></i>
        <i class="wms wms-file upload-icon"></i>
        <p class="upload-text">{{ttfFile}}</p>
      </div>
      <label class="upload-icon-button col-xs-4" *ngIf="!cssFile" style="margin-left: 10px">
        <i class="wms wms-upload upload-icon"></i>
        <p class="upload-text">{{locale.LABEL_UPLOAD_CSS_FILE}}</p>
        <input   id="import-project-file-upload1"
                 [ngModel]="cssFile"
                 type="file"
                 (change)="validateCSSFile($event)"
                 name="wmCSSFile" accept=".css" class="wm-file-uploader">
      </label>
      <div class="upload-icon-button uploaded-file-button" *ngIf="cssFile" style="margin-left: 10px">
        <i class="wms wms-cancel upload-icon cross-icon" (click)="removeFile('css')"></i>
        <i class="wms wms-file upload-icon"></i>
        <p class="upload-text">{{cssFile}}</p>
      </div>
    </div>
    <div class="input-container">
      <label>Icon Library Name</label>
      <div class="input-content">
        <input  type="text" [(ngModel)]="libName" name="wmLibName"  (ngModelChange)="checklibname(libName)"   [disabled]="!(cssFile && ttfFile)"/>
        <button  *ngIf="!dialogeAction" class=" button-primary btn app-button" [disabled]="!(libName && cssFile && ttfFile)" (click)="validateFileName()">Save</button>
      </div>
    </div>
  </div>
